import { QuestionnaireModel } from "../../../models/QuestionnaireModel";
import { setDefaultLanguage } from "../../../models/utilities/translationUtilities";
import { ActionTypes } from "../../actions/types";
import { ENABLE_LEGACY_BROWSER_WARNING, QUESTIONNAIRE_CHANGED } from "../../actions";

export const questionnaireSliceReducer = (
    state: QuestionnaireModel,
    action: ActionTypes,
): QuestionnaireModel => {
    switch (action.type) {
        case QUESTIONNAIRE_CHANGED:
            setDefaultLanguage(action.questionnaire.defaultLanguage);
            return action.questionnaire;
        case ENABLE_LEGACY_BROWSER_WARNING:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    ENABLE_LEGACY_BROWSER_WARNING: action.enableWarning,
                },
            };
        default:
            return state;
    }
};
